module.exports = __webpack_public_path__ + "static/media/service4.736ed298.png";